import { render, staticRenderFns } from "./groupsForm.vue?vue&type=template&id=66d7a57b&"
import script from "./groupsForm.vue?vue&type=script&lang=js&"
export * from "./groupsForm.vue?vue&type=script&lang=js&"
import style0 from "./groupsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports